import React, {PureComponent, Fragment} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import uniqueId from 'lodash/uniqueId';
import set from 'lodash/set';
import {VideoControls} from '../';

export default class RtcRemotePlayer extends PureComponent {
  static propTypes = {
    stream: PropTypes.shape({}).isRequired,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.array,
    ]).isRequired,
    isVideoRemotelyMuted: PropTypes.bool,
    isVideoPlaying: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    isVideoRemotelyMuted: false,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const {stream} = nextProps;
    const {stream: prevStream} = prevState;

    return stream && stream === prevStream ? null : {isVideoMuted: false};
  }

  state = {
    videoId: uniqueId('video_'),
    isVideoMuted: false,
    isAudioMuted: false,
  };

  componentDidMount() {
    const {stream} = this.props;
    if (stream) {
      this.playStream(stream);
    }
  }

  componentDidUpdate(prevProps) {
    const {isVideoPlaying, stream} = this.props;
    const {isAudioMuted} = this.state;
    const {stream: prevStream, isVideoPlaying: prevIsVideoPlaying} = prevProps;
    const streamChanged = !prevStream || !stream || stream !== prevStream;
    const isVideoPlaybackChanged = isVideoPlaying !== prevIsVideoPlaying;
    if (prevStream && streamChanged) {
      prevStream.close();
    }
    if (stream && streamChanged) {
      this.playStream(stream);
    }
    if (stream && isVideoPlaybackChanged && !isAudioMuted) {
      const {disableAudio, enableAudio} = stream;
      if (isVideoPlaying) {
        disableAudio();
      } else {
        enableAudio();
      }
    }
  }

  componentWillUnmount() {
    const {stream} = this.props;
    if (!stream) {
      return;
    }
    const streamId = stream.getId();
    stream.close();
    this.removePlayerDiv(streamId);
  }

  // remove player div added directly by Agora.io
  removePlayerDiv = (streamId) => {
    const player = this.playerDiv(streamId);
    if (player) {
      player.parentNode.removeChild(player);
    }
  };

  playerDiv = streamId => streamId && document.getElementById(`player_${streamId}`);

  onAudioClick = (isAudioMuted) => {
    const {stream: {disableAudio, enableAudio, isVideoPlaying}} = this.props;
    const toggleAudio = isAudioMuted ? disableAudio : enableAudio;
    if (!isVideoPlaying) {
      this.setState({isAudioMuted}, toggleAudio);
    }
  };

  onVideoClick = (isVideoMuted) => {
    const {stream: {disableVideo, enableVideo}} = this.props;
    const toggleVideo = isVideoMuted ? disableVideo : enableVideo;
    toggleVideo();
    this.setState({isVideoMuted});
  };

  playStream = (stream) => {
    const {videoId} = this.state;
    stream.play(videoId);

    set(stream, 'player.video.controls', false);
  };

  render = () => {
    const {videoId, isVideoMuted} = this.state;
    const {stream, children, isVideoPlaying, isVideoRemotelyMuted} = this.props;
    const {hasVideo = () => false, hasAudio = () => false} = stream || {};
    const showAvatar = !hasVideo() || isVideoMuted || isVideoRemotelyMuted;
    const videoClassnames = classNames(
      'team-player__video',
      {
        'team-player__video_muted': showAvatar,
      }
    );

    return (
      <Fragment>
        <div id={videoId} className={videoClassnames}>
          {showAvatar && children}
        </div>
        <VideoControls
          isVideoPlaying={isVideoPlaying}
          hasAudio={hasAudio()}
          hasVideo={hasVideo() && !isVideoRemotelyMuted}
          onAudioClick={this.onAudioClick}
          onVideoClick={this.onVideoClick}
          stream={stream}
        />
      </Fragment>
    );
  };
}
